import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'
import { isValidDateString } from '@/utils/api.util'
import moment from 'moment'

class SystemVariableService extends CrudService {
  constructor() {
    super(API_RESOURCE.SYSTEM_VARIABLE)
  }

  uploadSystemVariables = async ({ type, file }) => {
    const form = new FormData()
    form.append('file', file)
    const response = await axios.post(`${this.resource}/${type}/upload`, form)
    return response.data
  }
}

export default SystemVariableService
